import { bunja } from 'bunja';
import { atom } from 'jotai';

import { getLocalStorageAtom } from '@flipster/react/misc/state/use-local-storage';
import { getFlipsterConfigsV1Key } from '@flipster/utils/localStorage';

import { authBunja } from '../auth/state';

export type DisplayedPnlType = 'unrealizedPnl' | 'netPnl';

export const pnlModeBunja = bunja(() => {
  const { userAtom } = bunja.use(authBunja);

  const pnlModeAtom = atom(
    (get) => {
      const user = get(userAtom);
      if (!user) return 'unrealizedPnl';

      const key = getFlipsterConfigsV1Key(user.userId, 'pnlMode');
      const localStorageAtom = getLocalStorageAtom(key, 'unrealizedPnl');
      return get(localStorageAtom);
    },
    (get, set, newValue: DisplayedPnlType) => {
      const user = get(userAtom);
      if (!user) return;

      const key = getFlipsterConfigsV1Key(user.userId, 'pnlMode');
      const localStorageAtom = getLocalStorageAtom(key, 'unrealizedPnl');
      set(localStorageAtom, newValue);
    },
  );

  return {
    pnlModeAtom,
  };
});

pnlModeBunja.debugLabel = 'pnlModeBunja';
